/* eslint-disable react/no-array-index-key */

import React, { useState } from "react";
 
const AgentActionTray = ({ steps = [], status }) => {

  // While generating (status === "thinking"): show all steps live.

  // When done: collapse to the latest. A manual click overrides the default.

  const isGenerating = status === "thinking";

  const [userToggled, setUserToggled] = useState(null);
 
  if (!steps || steps.length === 0) return null;
 
  const expanded = userToggled !== null ? userToggled : isGenerating;
 
  // Expanded: all steps. Collapsed: only the most-recent step.

  const visibleSteps = expanded ? steps : [steps[steps.length - 1]];

  const hasMultiple = steps.length > 1;
 
  return (
<div className="action-tray">
<button

        type="button"

        className="action-tray-toggle"

        onClick={() => setUserToggled((v) => (v === null ? !expanded : !v))}

        aria-expanded={expanded}
>
<div className="action-rows">

          {visibleSteps.map((step, i) => {

            const done = step.status === "done";

            return (
<div key={step.id || i} className={`action-row ${done ? "done" : "progress"}`}>
<span className="action-icon">

                  {done ? (
<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
<circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2" />
<path d="M8 12l3 3 6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
</svg>

                  ) : (
<span className="action-spinner" />

                  )}
</span>
<span className="action-label">{done ? (step.done_label || step.label) : step.label}</span>
</div>

            );

          })}
</div>

        {hasMultiple && (
<span className={`action-chevron ${expanded ? "open" : ""}`} aria-hidden="true">
<svg viewBox="0 0 24 24" width="16" height="16">
<path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
</svg>
</span>

        )}
</button>
</div>

  );

};
 
export default AgentActionTray;
 